import React, { FC, ReactElement } from 'react'

import WixLogo from '../icons/WixLogo.svg'
import s from './WixMobileHeader.scss'

type WixMobileHeaderType = {
  leftContent?: ReactElement
  rightContent?: ReactElement
}

export const WixMobileHeader: FC<WixMobileHeaderType> = ({ children, leftContent, rightContent }) => {
  return (
    <header className={s.header}>
      <div className={s.column}>{leftContent}</div>
      <div className={s.column}>
        <WixLogo height="24" />
      </div>
      <div className={s.column}>{rightContent}</div>
    </header>
  )
}
